import {
  redmineUser,
  project
} from './definition'

export default {
  [redmineUser] (state, value) {
    state.redmineUser = value
  },
  [project] (state, value) {
    state.project = value
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/store/mutations.js